import React from "react"
import Button from "@material-ui/core/Button"
import TextField from "@material-ui/core/TextField"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import CircularProgress from "@material-ui/core/CircularProgress"
import { navigate } from "gatsby"
// import withDrupalOauthConsumer from "../drupal-oauth/withDrupalOauthConsumer"
import axios from "axios"

const windowGlobal = typeof window !== "undefined" && window
export const isBrowser = () => typeof window !== "undefined"
const SERVER_URL = process.env.GATSBY_SERVER_BASE_URL

// let organization_url_param = ""
// organization_url_param =
//   isBrowser() && window.localStorage.getItem("organization")
//     ? window.localStorage["organization"]
//     : {}

var years = []
var months = []
var days = []
var i
for (i = 1920; i <= 2020; i++) {
  years.push({ year: String(i) })
}
for (i = 1; i <= 12; i++) {
  months.push({ month: String(i) })
}
for (i = 1; i <= 31; i++) {
  days.push({ day: String(i) })
}

class SignInForm extends React.Component {
  state = {
    open: true,
    processing: false,
    lastName: "",
    organization:
      isBrowser() && window.localStorage.getItem("organization")
        ? window.localStorage["organization"]
        : "No organization",
    year: "YYYY",
    month: "MM",
    day: "DD",
    error: null,
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleCancel = () => {
    this.setState({
      error: null,
    })
  }

  handleSubmit = async event => {
    console.log(this.state)
    let bdayFlag =
      parseInt(this.state.month) >= 1 &&
      parseInt(this.state.month) <= 12 &&
      parseInt(this.state.day) >= 1 &&
      parseInt(this.state.day) <= 31 &&
      parseInt(this.state.year) >= 1920 &&
      parseInt(this.state.year) <= 2008

    if (bdayFlag !== true) {
      bdayFlag = "Birthdate is not valid."
    }
    this.setState({ processing: true, birthdayValid: bdayFlag })
    let { lastName, year, month, day, organization } = this.state

    var dob = year + "-" + month + "-" + day
    lastName = lastName.trim()
    windowGlobal.localStorage["lastName"] = lastName
    windowGlobal.localStorage["dob"] = dob
    if (lastName === "") {
      this.setState({
        processing: false,
        error: "Please enter name below.",
      })
      this.props.updateAuthenticatedUserState(false)
    } else {
      try {
        let res = await axios.post(SERVER_URL+"/checkins/v1/login", {
        // let res = await axios.post("http://35.232.53.48/login", {
        // let res = await axios.post("https://gcp.mahimma.org/login", {
          lastName: lastName,
          organization: organization,
          dob: dob,
        })

        if (res.data.loginState === true) {
          if (res.data.newUser === false) {
            this.setState({
              processing: false,
              error: "Authenticated!",
            })

            windowGlobal.localStorage["contact_url"] =
              res.data.result.attributes.url
            windowGlobal.localStorage["userID"] = windowGlobal.localStorage[
              "contact_url"
            ].split("/")[6]
            windowGlobal.localStorage["name"] = res.data.result.Name
            windowGlobal.localStorage["fname"] = windowGlobal.localStorage[
              "name"
            ].split(" ")[0]
            windowGlobal.localStorage["lname"] = windowGlobal.localStorage[
              "name"
            ].split(" ")[1]
            if (res.data.result.MobilePhone === null)
              windowGlobal.localStorage["update_phone"] = "Yes"
            else windowGlobal.localStorage["update_phone"] = "No"
            navigate("/formstack_short/")
          } else {
            navigate("/formstack_long/")
          }
        } else {
          this.setState({
            processing: false,
            error: "Please enter all fields correctly below.",
          })
          this.props.updateAuthenticatedUserState(true)
        }
      } catch (err) {
        this.setState({
          processing: false,
          error: "Unable to authenticate.",
        })
        this.props.updateAuthenticatedUserState(false)
      }
    }
  }
  
  testSubmit = async event => {
    let res = await axios.post("https://gcp.mahimma.org/login", {
          lastName: 'Sapre',
          organization: '',
          dob: '01-01-1990',
        })
    console.log(res.data)    
  }

  render() {
    const { error, processing } = this.state
    // const classes = useStyles()

    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Enter Last Name and Date of Birth
          </DialogTitle>
          <DialogContent>
            {error && <p>{error}</p>}
            <TextField
              margin="dense"
              name="lastName"
              label="Last Name"
              style={{
                paddingBottom:"30px"
              }}
              type="text"
              fullWidth
              onChange={event =>
                this.setState({ [event.target.name]: event.target.value })
              }
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <input
                type="number"
                min="1"
                max="12"
                placeholder="MM"
                style={{
                  width: "20%",
                  border: 0,
                  fontFamily:'Helvetica'
                }}
                onChange={event => {
                  let _m = event.target.value
                  if (_m < 10) {
                    _m = ("0" + _m).slice(-2)
                  } else {
                    _m = "" + _m
                  }
                  this.setState({
                    month: _m,
                    birthdayValid: "",
                  })
                }}
              ></input>
              <input
                type="number"
                min="1"
                max="31"
                placeholder="DD"
                style={{
                  width: "20%",
                  border: 0,
                  fontFamily:'Helvetica'
                }}
                onChange={event => {
                  let _d = event.target.value
                  if (_d < 10) {
                    _d = ("0" + _d).slice(-2)
                  } else {
                    _d = "" + _d
                  }
                  this.setState({
                    day: _d,
                    birthdayValid: "",
                  })
                }}
              ></input>
              <input
                type="number"
                min="1930"
                max="2008"
                placeholder="YYYY"
                style={{
                  width: "25%",
                  border: 0,
                  fontFamily:'Helvetica'
                }}
                onChange={event => {
                  let _y = event.target.value
                  this.setState({
                    year: _y,
                    birthdayValid: "",
                  })
                }}
              ></input>
            </div>
            <div>{this.state.birthdayValid}</div>
          </DialogContent>
          <DialogActions>
            {processing ? (
              <CircularProgress />
            ) : (
              <Button
                onClick={this.handleSubmit}
                color="primary"
                variant="contained"
              >
                Check in
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

// export default withDrupalOauthConsumer(SignInForm)
export default SignInForm
